/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lifecycle state of an OEM connection row.
 */
export const ConnectionState = {
    Active: 'active',
    Revoked: 'revoked',
    Expired: 'expired',
    Error: 'error',
    NotConnected: 'not-connected'
} as const;
export type ConnectionState = typeof ConnectionState[keyof typeof ConnectionState];

